module.exports = __webpack_public_path__ + "img/header-engagementRings025Carat@2x.2e41333.jpg";